import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Table } from '../../../../common/table'
import {
  selectIds,
  selectIsLoadingScale,
  selectItem,
  selectTableTitle,
} from './store/slice'
import { FormatVal } from './table/FormatVal'
import { TbodyTable } from './table/TbodyTable'

export const IndustryScaleTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectIds)
  const tableTitle = useSelector(selectTableTitle)
  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectIsLoadingScale)

  const getSchema = () => {
    return tableTitle.map((item) => {
      return {
        title: item.label,
        colId: item.key,
        thStyle: { justifyContent: 'flex-end' },
        render: (val, { rowId }) => {
          return (
            <FormatVal
              val={val}
              locale={locale}
              year={item.key}
              rowId={rowId}
            />
          )
        },
      }
    })
  }

  return (
    <Table
      isLoading={isLoading}
      ids={ids}
      isStickyFirstCol
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectItem}
      schema={getSchema()}
      renderTBody={() => (
        <TbodyTable
          ids={ids}
          getDataFromRedux={selectItem}
          schema={getSchema()}
        />
      )}
    />
  )
}

IndustryScaleTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
